<template>
  <div class="table-box">
      <table v-if="group.length > 0" cellspacing="3">
          <tr class="top"><td v-for="(g,index) in group" :key="index" :colspan="g.list.length" v-html="g.name"></td></tr>
          <tr class="middle">
              <td v-for="(w,index) in weidu" :key="index"  v-html="w.name"></td>
          </tr>
          <tr class="value">
              <td v-for="(w,index) in weidu" :key="index"  v-html="w.value"></td>
          </tr>
      </table>
  </div>
</template>

<script>
import { weidu } from './config'
export default {
  props: ["model"],
  data() {
    return {
      weidu: [],
      group:[]
    };
  },
  mounted() {
    if (this.model) {
      this.weidu = this.model;
    }
    this.renderTable()
  },
  methods:{
      renderTable(){
          this.group = []
          weidu.map(item=>{
              let hasI = this.group.filter(g=>g.name==item.group)
              if(hasI.length == 0){
                  this.group.push({name:item.group,list:[
                      item
                  ]})
              }else{
                  hasI[0].list = hasI[0].list.concat(item)
              }
          })
          this.weidu = []
          this.group.map(item=>{
              item.list.map(l=>{
                  this.weidu.push(l)
              })
          })
      }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  margin:0px auto;
  table{
    background:#fff;
    border:2px solid #333;
    td{
        padding: 4px 10px;
        text-align: center;
    }
    .top{
        color:#fff;
        background:#10253f;
        font-size:16px;
        font-weight: bolder;
    }
    .middle{
        color:#333;
        background:#c6d9f1;
        font-size:16px;
        font-weight: bold;
    }
    .value{
        background: #fff;
        color:#333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/table/normal.vue